import { jsx as r } from "react/jsx-runtime";
const e = ({
  size: t
}) => {
  switch (t) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.53418 11.7683L5.76501 7.99915L9.53418 4.22998L10.2367 4.93248L7.17001 7.99915L10.2367 11.0658L9.53418 11.7683Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M14.2988 17.6525L8.64502 11.9987L14.2988 6.34497L15.3525 7.39872L10.7525 11.9987L15.3525 16.5987L14.2988 17.6525Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M11.9165 14.713L7.20502 10.0015L11.9165 5.29004L12.7946 6.16816L8.96127 10.0015L12.7946 13.8348L11.9165 14.713Z",
          fill: "currentColor"
        }
      );
  }
}, l = ({
  size: t
}) => {
  switch (t) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.53253 12.129L5.40503 8.00152L9.53253 3.87402L10.5934 4.93486L7.5267 8.00152L10.5934 11.0682L9.53253 12.129Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M14.3012 18.1926L8.10999 12.0013L14.3012 5.81006L15.8925 7.40131L11.2925 12.0013L15.8925 16.6013L14.3012 18.1926Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M11.9144 15.1588L6.755 9.99946L11.9144 4.84009L13.2404 6.16613L9.40709 9.99946L13.2404 13.8328L11.9144 15.1588Z",
          fill: "currentColor"
        }
      );
  }
}, a = ({
  size: t = "md",
  weight: L = "default"
}) => {
  switch (L) {
    case "bold":
      return /* @__PURE__ */ r(l, { size: t });
    case "book":
    case "default":
      return /* @__PURE__ */ r(e, { size: t });
  }
};
export {
  a as default
};
//# sourceMappingURL=DIconCaretLeft.js.map
